import { IconName, NoddiIcon } from 'noddi-ui-common';

export const InstructionRow = ({
  icon,
  title,
  description
}: {
  icon: IconName;
  title: string;
  description: string;
}) => (
  <div className='flex gap-2'>
    <div className='size-6 items-center justify-center rounded-md bg-grey/15'>
      <NoddiIcon name={icon} />
    </div>
    <div className='flex flex-col gap-1'>
      <p>{title}</p>
      <p className='text-3.5 text-black/70'>{description}</p>
    </div>
  </div>
);
